import CryptoJS from 'crypto-js';
import moment from 'moment';

const isObjEmpty = (obj) => {
  return Object.keys(obj).length === 0;
}

const createObjPresignedUrl = async (file) => {
  return {
    'file': {
      'filename': file.name,
      'byte_size': file.size,
      'checksum': await getMd5HashFromFile(file),
      'content_type': file.type
    }
  }
}

const getBinaryFile = (file) => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };
    reader.readAsBinaryString(file)
  }) 
}

const getMd5HashFromFile = async (file) => {
  const binary = await getBinaryFile(file)
  let digest = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(binary));
  return digest.toString(CryptoJS.enc.Base64)
}

const getErrorMessage = (error) => {
  return Array.isArray(error) ? error[0] : error;
}
const NEW_TRAININGS_INFO_RELEASE_DATE = '2025-07-04T00:00:00Z';

const shouldShowNewBadge = (createdAt, user) => {
  if (!createdAt) return false;

  const nDays = user?.new_trainings_info_days ?? 30;
  const created = moment(createdAt);
  const release = moment(NEW_TRAININGS_INFO_RELEASE_DATE);
  const nDaysAgo = moment().subtract(Number(nDays), 'days');

  return created.isAfter(release) && created.isSameOrAfter(nDaysAgo);
};

export {
  isObjEmpty,
  createObjPresignedUrl,
  getBinaryFile,
  getErrorMessage,
  shouldShowNewBadge,
}
